import { z } from "zod"
import { asMarketplaceId } from "../marketplace-id"

export const AUTOMATIC_PREPARATION_COHORT = {
  marketplace: asMarketplaceId("shop-apotheke-it"),
  masterCategory: "clothing",
} as const

export const RUN_PREPARATION_STAGE = {
  preflight: "preflight",
  extract: "extract",
  copy: "copy",
  values: "values",
  validate: "validate",
  build: "build",
  ready: "ready",
} as const

export const runPreparationStageSchema = z.enum(RUN_PREPARATION_STAGE)
export type RunPreparationStage = z.infer<typeof runPreparationStageSchema>

export const runPreparationSchema = z.object({
  requestedRevision: z.number().int().nonnegative(),
  latestEventId: z.number().int().nullable(),
  affectedDependencies: z.array(z.string()),
  plan: z.array(runPreparationStageSchema),
  stage: runPreparationStageSchema,
  status: z.enum(["queued", "running", "blocked", "ready", "disabled"]),
  attempts: z.number().int().nonnegative(),
  attemptToken: z.string().nullable(),
  leaseExpiresAt: z.string().nullable(),
  blocker: z.string().nullable(),
  activeWorkId: z.string().nullable().optional(),
  activeWorkFingerprint: z.string().nullable().optional(),
  wakeRevision: z.number().int().nonnegative().optional(),
  servicedWakeRevision: z.number().int().nonnegative().optional(),
  nextAttemptAt: z.string().nullable().optional(),
  oldestUnresolvedAt: z.string().nullable().optional(),
  uncoveredOutsideMembershipCount: z.number().int().nonnegative().optional(),
  lastServicedAt: z.string().nullable().optional(),
  completed: z.array(
    z.object({
      stage: runPreparationStageSchema,
      inputFingerprint: z.string(),
      evidenceId: z.string().nullable(),
      completedAt: z.string(),
    })
  ),
  artifactId: z.number().int().nullable(),
  requestedAt: z.string(),
  updatedAt: z.string(),
})
export type RunPreparation = z.infer<typeof runPreparationSchema>

// Public projection never exposes lease credentials.
export const runPreparationSummarySchema = runPreparationSchema.omit({
  attemptToken: true,
  leaseExpiresAt: true,
})
export type RunPreparationSummary = z.infer<typeof runPreparationSummarySchema>
